import React, { Component } from "react";
import EquipmentList from "./EquipmentList";

class EquipmentMain extends Component {
  renderBody = () => {
    const { permissions, projectId } = this.props;
    return <EquipmentList permissions={permissions} projectId={projectId} />;
  };

  render() {
    return <React.Fragment>{this.renderBody()}</React.Fragment>;
  }
}

export default EquipmentMain;
